import script from "./WCDesktopSubNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCDesktopSubNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./WCDesktopSubNavbar.vue?vue&type=style&index=0&id=2be86d44&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be86d44"]])

export default __exports__